$(document).ready(function () {
  var $stickyWrapper = $("#Sticky-wrapper");

  if (!$stickyWrapper.length) {
    return;
  }

  var $inlineCta = $("[data-inline-atc-anchor]").first();

  if (!$inlineCta.length) {
    $stickyWrapper.addClass("fixed").removeClass("unfixed");
    return;
  }

  var showSticky = function () {
    $stickyWrapper.addClass("fixed").removeClass("unfixed");
  };

  var hideSticky = function () {
    $stickyWrapper.addClass("unfixed").removeClass("fixed");
  };

  var updateStickyState = function (isInlineCtaVisible) {
    if (isInlineCtaVisible) {
      hideSticky();
      return;
    }

    showSticky();
  };

  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        updateStickyState(entry.isIntersecting);
      },
      {
        threshold: 0.01,
      }
    );

    observer.observe($inlineCta[0]);
    return;
  }

  var isElementInViewport = function (element) {
    var rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  };

  var fallbackHandler = function () {
    updateStickyState(isElementInViewport($inlineCta[0]));
  };

  fallbackHandler();
  $(window).on("scroll resize", fallbackHandler);
});
